["DOMContentLoaded", "init:related-slider"].forEach( eventName => {
    document.addEventListener(eventName, () => {
        const relatedSlider = document.querySelector(".related-products__content");
        const relatedButtonPrev = document.querySelector('.related-products__controls--prev');
        const relatedButtonNext = document.querySelector('.related-products__controls--next');
        const relatedPagination = document.querySelector('.related-products__controls-pagination');
        const currentConfig = createConfig(relatedButtonPrev,relatedButtonNext,relatedPagination);
        initSlider(relatedSlider, currentConfig)
    })
})

function createConfig(buttonPrev,buttonNext,pagination) {
    const sliderConfig = {
        breakpoints: {
            0: {
                slidesPerGroup: 2,
                slidesPerView: 2,
                spaceBetween: 4.18,
                grid: {
                    rows: 2,
                    fill: "row",
                }
            },
            576: {
                slidesPerGroup: 1,
                slidesPerView: 2,
                spaceBetween: 10,
                grid: {
                    rows: 1,
                }
            },
            991: {
                slidesPerGroup: 1,
                slidesPerView: 3,
                spaceBetween: 10
            },
            1199: {
                slidesPerGroup: 1,
                slidesPerView: 4,
                spaceBetween: 10
            },
            1400: {
                slidesPerGroup: 1,
                slidesPerView: 5,
                spaceBetween: 10
            },
        }
    };
    
    if (buttonPrev && buttonNext) {
        sliderConfig.navigation = { nextEl: buttonNext, prevEl: buttonPrev };
    }
    if (pagination) {
        sliderConfig.pagination = {
            el: pagination,
            type: "fraction"
        }
    }

    return sliderConfig;
}


function initSlider(swiperElement, swiperSettings) {
    if (!Swiper || !swiperElement || swiperElement.swiper) return;
    return new Swiper(swiperElement, swiperSettings);
};
